import ComboboxInput from '../Reusable/Form/ComboboxInput';
import APIS from '../../constant/EndPoint';
import TextField from '../Reusable/Form/TextInput';
import ProductTypeComboboxInput from './ProductTypeCombox';

const OrderForm = ({ errors, register, setValue, getValues, clearErrors, setOpenAddSenderPopup,
  openAddSenderPopup,
  setOpenAddReceiverPopup,
  openAddReceiverPopup, fields, remove, append, profile, handleSetDeliveryCharge }: any) => {


  const handleSubProduct = () => {
    // need to implement auto focus
    // document.getElementById("sub-product").getElementsByTagName("input")[0].focus()
    append({
      package_type: null,
      piece: 1,
      weight: 1,
    })

  }

  return (
    <>
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-x-4 px-4">
        <>
          <ComboboxInput
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            register={register("vendor")}
            errors={errors?.vendor}
            name={"vendor"}
            label={"Vendor/Merchant"}
            setValue={setValue}
            placeholder={"Search Vendor/Merchant"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"barnch"}
            register={register("pickup_branch", {
              required: "Pickup branch is required",
            })}
            errors={errors?.pickup_branch}
            name={"pickup_branch"}
            label={"From"}
            props={{ is_active: true }}
            setValue={setValue}
            getValues={getValues}
            placeholder={"Search Pickup Branch"}
            clearErrors={clearErrors}
            disabled={!profile?.is_superuser}
          />
          <ComboboxInput
            url={APIS.LOCATION}
            props={{ level: 3, is_active: true }}
            queryKey={"location"}
            register={register(
              `destination` as const,
              {
                required: "Destination city is required",
              }
            )}
            errors={errors?.destination}
            name={"destination"}
            label={"Destination"}
            setValue={setValue}
            getValues={getValues}
            placeholder={"Search Destination City"}
            clearErrors={clearErrors}
          />
        </>
      </div>
      <div className="grid grid-cols-2">
        <div>
          <div className="w-full mt-6 flex justify-left px-4 gap-x-2 uppercase font-extrabold items-center">
            <span className="text-[#5E5757] font-bold text-sm">
              Sender Informations
            </span>
          </div>
          <div className="w-full flex justify-center items-center px-4">
            <div className="w-full">
              <ComboboxInput
                url={APIS.CUSTOMER}
                queryKey={"customer"}
                register={register('sender' as const,
                  {
                    required: "Sender is required",
                  })}
                errors={errors?.sender}
                name={`sender`}
                setValue={setValue}
                placeholder={"Search Sender"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button className="border px-4 p-2 mt-3 " type='button' onClick={() => setOpenAddSenderPopup(!openAddSenderPopup)}>+</button>
          </div>
        </div>
        <div>
          <div className="w-full mt-6 flex justify-left px-4 gap-x-2 uppercase font-extrabold items-center">
            <span className="text-[#5E5757] font-bold text-sm">
              Receiver Informations
            </span>
          </div>
          <div className="w-full flex justify-center items-center px-4">
            <div className="w-full">
              <ComboboxInput
                url={APIS.CUSTOMER}
                queryKey={"customer"}
                register={register('receiver' as const,
                  {
                    required: "Receiver is required",
                  })}
                errors={errors?.receiver}
                name={`receiver`}
                setValue={setValue}
                placeholder={"Search Receiver"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button className="border px-4 p-2 mt-3 " type='button' onClick={() => setOpenAddReceiverPopup(!openAddReceiverPopup)}>+</button>
          </div>
        </div>
      </div>
      <div className="w-full mt-6 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center">
        <div className="text-[#5E5757] font-bold text-sm">
          Shipment Informations
        </div>

      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-2 px-4">
        <ComboboxInput
          url={APIS.SERVICE_TYPE}
          queryKey={"service-type"}
          register={register(`service_type` as const, {
            required: "Service Type is required",
          })}
          errors={errors?.service_type}
          name={`service_type`}
          label={"Service Type"}
          setValue={setValue}
          placeholder={"Search Service Type"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.PAYMENT_METHOD_TYPE}
          queryKey={"payment-method"}
          register={register(`payment_method` as const, {
            required: "Payment Method  is required",
          })}
          errors={errors?.product_type}
          name={`payment_method`}
          label={"Payment Method"}
          setValue={setValue}
          placeholder={"Search Payment Method"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
      <hr className="mt-6" />
      <div id='sub-product'>
        {fields.map((field: any, index: any) => {
          return (
            <div key={index}>
              <div className="relative w-full mt-2 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center">
                <div className="text-[#5E5757] font-bold text-xs">
                  Order {index + 1}
                </div>
                <button
                  type="button"
                  className="rounded p-1 m-1 border border-gray-400 text-xs"
                  disabled={index === 0 ? true : false}
                  onClick={() => remove(index)}
                >
                  Remove ({index + 1})
                </button>
              </div>
              <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-x-4 px-4">
                <ProductTypeComboboxInput
                  url={APIS.PRODUCT_TYPE}
                  queryKey={"product-type"}
                  register={register(`order_items.${index}.package_type` as const, {
                    required: "Product Type is required",
                  })}
                  errors={errors?.order_items?.[index]?.package_type}
                  name={`order_items.${index}.package_type`}
                  label={"Product Type"}
                  setValue={setValue}
                  placeholder={"Search Product Type"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                  value={getValues()["order_items"][index]["package_type"]}
                />
                <TextField
                  label={"Pcs."}
                  register={register(`order_items.${index}.piece` as const, {
                    required: "Piece is required",
                  })}
                  errors={errors?.order_items?.[index].piece}
                />
                <TextField
                  label={"Weight(Kg)"}
                  register={register(`order_items.${index}.weight` as const, {
                    required: "Weight is required",
                  })}
                  errors={errors?.order_items?.[index]?.weight}
                />

              </div>
            </div>
          );
        })}
        <div className="w-full flex justify-end">
          <button
            type="button"
            className="rounded p-1 m-1 border border-gray-400 text-xs"
            onClick={() => handleSubProduct()}
          >
            Add Product
          </button>
        </div>

        <hr />
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-x-2 px-4">
        <ComboboxInput
          url={APIS.REFERENCE_TYPE}
          queryKey={"reference-type"}
          register={register(`reference_type`)}
          errors={errors?.reference_type}
          name={"reference_type"}
          label={"Document Type"}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search Document Type"}
          clearErrors={clearErrors}
        />

        <TextField
          label={"Doc. Number"}
          placeholder={"Doc. Number"}
          register={register(`reference_number`)}
          errors={errors?.reference_number}
        />
        <TextField
          type="date"
          label={"Document Date"}
          register={register(`reference_date` as const, {
            required: false,
          })}
          errors={errors?.reference_date}
        />
        <TextField
          type="text"
          label={"Goods Value"}
          register={register(`order_value` as const, {
            required: false,
          })}
          errors={errors?.reference_date}
        />
        <div className='flex gap-x-2'>
          <TextField
            type="text"
            label={"Charge"}
            register={register(`delivery_charge` as const, {
              required: "Delivery Charge is required",
            })}
            errors={errors?.delivery_charge}
          />
          <div className='h-full w-full relative'>
            <button type='button' onClick={handleSetDeliveryCharge} className='whitespace-nowrap flex justify-center items-center my-2 h-10 text-gray-200 bg-[#EEF5F4] rounded p-4 absolute bottom-0'>Calculate(F1)</button>
          </div>
        </div>
        <TextField
          type="text"
          label={"COD Amount"}
          register={register(`cod` as const, {
            required: false,
          })}
          errors={errors?.cod}
        />
        <TextField
          label={"Remarks"}
          register={register(`note` as const, {
            required: false,
          })}
          errors={errors?.note}
        />
      </div>
    </>
  )
}

export default OrderForm